import React, { useState } from "react";

const CustomTooltip = ({ children, text }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = () => {
    setVisible(true);
  };

  const handleMouseLeave = () => {
    setVisible(false);
  };

  const handleMouseMove = (e) => {
    setPosition({ x: e.clientX, y: e.clientY });
  };

  return (
    <span
      style={{
        position: "relative",
        display: "inline-block",
        cursor: "pointer",
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      {children}
      {visible && (
        <span
          style={{
            position: "fixed",
            backgroundColor: "black",
            color: "white",
            padding: "8px 12px",
            borderRadius: "4px",
            fontSize: "15px",
            whiteSpace: "nowrap",
            zIndex: 9999,
            top: `${position.y + 15}px`,
            left: `${position.x + 15}px`,
            opacity: 1,
            visibility: "visible",
            transition: "opacity 0.1s ease, visibility 0.1s ease",
            pointerEvents: "none",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
};

export default CustomTooltip;